import React, { useState, useEffect, useCallback } from 'react';
import UserItem from '../Components/UserItem';
import AreaItem from '../Components/AreaItem';
import { useRoles } from '../verRolesContext';
import { Box, MenuItem, Select, FormControl, TextField, InputLabel, Typography, List, ListItem, InputAdornment, CircularProgress, Fab, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import VerTodosRoles from '../Components/VerTodosRoles';
import { useBody } from '../../Body/state/BodyContext';
import { useAreas } from '../../Areas/State/AreasContext';
import { ModalGeneral } from '../../Componentes/ModalGeneral';
import { useMediaQuery } from '@mui/material';

let searchTimeout;

const VerRoles = () => {
    const { getAreasTree } = useAreas();
    const { users, getUsers, getUserByUsername } = useRoles();
    const { setMessage } = useBody();
    const [loading, setLoading] = useState(false);
    const [allAreas, setAllAreas] = useState([]);
    const [areas, setAreas] = useState([]);
    const [openModalVer, setOpenModalVer] = useState(false);
    const [tipoBusqueda, setTipoBusqueda] = useState("usuario");
    const matches = useMediaQuery('(min-width:1185px)');

    const fetchUsers = async () => {
        setLoading(true);
        try {
            await getUsers();
        } catch (error) {
            console.error("Error obteniendo los usuarios:", error);
            setMessage("Error obteniendo los usuarios.");
        }
        setLoading(false);
    };

    const fetchAreas = async () => {
        setLoading(true);
        try {
            const response = await getAreasTree(true);
            setAllAreas(response);
            setAreas(response);
        } catch (error) {
            console.error("Error obteniendo las áreas:", error);
            setMessage("Error obteniendo las áreas.");
        }
        setLoading(false);
    };


    useEffect(() => {
        if (tipoBusqueda === 'usuario') {
            fetchUsers();
        } else if (tipoBusqueda === 'area') {
            fetchAreas();
        }
    }, [tipoBusqueda]);

    const handleChange = (e) => {
        const patronBuscado = e.target.value;

        if (searchTimeout) clearTimeout(searchTimeout);

        if (patronBuscado.length >= 3) {
            setLoading(true);
            searchTimeout = setTimeout(async () => {
                if (tipoBusqueda === 'usuario') {
                    try {
                        await getUserByUsername(patronBuscado);
                    } catch (error) {
                        console.error("Error en la búsqueda de usuarios:", error);
                        setMessage("Error en la búsqueda de usuarios");
                    }
                } else if (tipoBusqueda === 'area') {
                    const areasFiltradas = allAreas.filter(area => area.name?.toLowerCase().includes(patronBuscado.toLowerCase()));
                    setAreas(areasFiltradas);

                }
                setLoading(false);
            }, 2000);
        }
    };

    const handleShowRoles = () => {
        setOpenModalVer(true);
    };

    const onClose = () => {
        setOpenModalVer(false);
    };

    return (
        <>
            <Box sx={{ px: '2%' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography
                        my={"40px"}
                        fontSize={matches ? "30px" : "28px"}
                    >
                        Gestión de Roles
                    </Typography>
                    <Tooltip title="Ver Roles Disponibles">
                        <Fab sx={[{ zIndex: 1, backgroundColor: "#B71234" }, { '&:hover': { backgroundColor: "#C5415C" } }]} onClick={handleShowRoles} aria-label="add">
                            <img alt="Ver Roles Disponibles" width="55%" height="55%" src={require('../../Iconos/ver_roles.png')} />
                        </Fab>
                    </Tooltip>
                </Box>

                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    alignItems={{ xs: 'stretch', sm: 'center' }}
                    width="100%"
                    marginBottom={2}
                    gap={2}
                >
                    <TextField
                        sx={{ flex: { sm: 2 }, backgroundColor: "white" }}
                        id="buscador"
                        label={tipoBusqueda === 'usuario' ? "Nombre del Usuario" : "Nombre del Área"}
                        onChange={handleChange}
                        variant="outlined"
                        helperText={tipoBusqueda === 'usuario' ? "Ingrese el nombre institucional del usuario que desea buscar." : "Ingrese el nombre del área que desea buscar."}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <FormControl
                        sx={{
                            flex: { sm: 1 },
                            minWidth: { sm: 160 },
                            marginTop: { xs: 0, sm: "-25px" }
                        }}
                    >
                        <InputLabel id="tipo-busqueda-label">Buscar por</InputLabel>
                        <Select
                            labelId="tipo-busqueda-label"
                            id="tipo-busqueda"
                            value={tipoBusqueda}
                            label="Buscar por"
                            onChange={(e) => setTipoBusqueda(e.target.value)}
                        >
                            <MenuItem value="usuario">Usuario</MenuItem>
                            <MenuItem value="area">Área</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {loading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "center", marginTop: '15px', marginRight: '15px' }}>
                        <CircularProgress color="primary" sx={{ marginRight: '15px' }} />
                        <Typography>Obteniendo {tipoBusqueda === 'usuario' ? 'Usuarios' : 'Áreas'}...</Typography>
                    </Box>
                ) : (
                    <Box sx={{ maxHeight: "100vh", overflowY: "auto" }}>
                        <List>
                            {tipoBusqueda === 'usuario' ? (
                                users.length > 0 ? (
                                    users.map((user, index) => (
                                        <UserItem key={index} user={user} />
                                    ))
                                ) : (
                                    <ListItem>No se encontraron usuarios.</ListItem>
                                )
                            ) : (
                                areas.length > 0 ? (
                                    areas.map((area, index) => (
                                        <AreaItem key={index} area={area} />
                                    ))
                                ) : (
                                    <ListItem>No se encontraron áreas.</ListItem>
                                )
                            )}
                        </List>
                    </Box>
                )}
            </Box>

            <ModalGeneral Contenido={<VerTodosRoles />} open={openModalVer} onClose={onClose} />
        </>
    );
};

export default VerRoles;
